var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelchairArmrests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.17,10.57H14.26c-.83,0-1.5,.67-1.5,1.5v28.33c0,.51,.27,.99,.69,1.26,.22,.14,5.39,3.58,5.39,12.29,0,.83,.67,1.5,1.5,1.5h7.83c.83,0,1.5-.67,1.5-1.5V12.07c0-.83-.67-1.5-1.5-1.5Zm-1.5,41.88h-4.88c-.47-7.54-4.4-11.48-6.04-12.81V13.57h10.91V52.45Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.28,24.36c-.22-.14-5.39-3.58-5.39-12.29,0-.83-.67-1.5-1.5-1.5h-7.83c-.83,0-1.5,.67-1.5,1.5V53.95c0,.83,.67,1.5,1.5,1.5h13.91c.83,0,1.5-.67,1.5-1.5V25.62c0-.51-.27-.99-.69-1.26Zm-2.31,28.09h-10.91V13.57h4.88c.47,7.54,4.4,11.48,6.04,12.81v26.07Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairArmrests);
export default __webpack_public_path__ + "static/media/wheelchair_armrests.2fbd95cb.svg";
export { ForwardRef as ReactComponent };